import { Col, Row } from "@/utils/bootstrap";
import SvgDropdownArrow from "./SvgDropdownArrow";
interface Props {
  title: string;
}
const OptinsDropdownTitle: React.FC<Props> = ({ title }) => {
  return (
    <Row className="w-100 m-0 d-flex align-items-center">
      <Col className="p-0 d-flex align-items-center col-auto">
        <div>{title}</div>
      </Col>
      <Col className="p-0 d-flex justify-content-end">
        <SvgDropdownArrow />
      </Col>
    </Row>
  );
};

export default OptinsDropdownTitle;
